import { WizardStepTrackerOptions, WizardStepTrackingStrategy } from '../interfaces/wizard-step';

export const DEFAULT_TRACKER_OPTIONS: WizardStepTrackerOptions = {
  trackingStrategy: WizardStepTrackingStrategy.DISCARD_ON_DIRTY
};
